<template>
    <div class="view budget-tasks" v-if="loaded">
        <app-sub-navbar parent="budget"></app-sub-navbar>
        <div class="container-fluid">
            <app-graph-filter @filterLoaded="loadChart = true" class="text-center" @filterChanged="redrawComponents()" parent="budget"></app-graph-filter>

            <div class="spacer col-12"></div>

            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <el-card class="box-card" v-if="loadChart">
                        <div slot="header" class="text-left">
                            <h3 class="inline">Sales revenue vs budget</h3>
                            <p :style="$store.state.budget.budgetGraphScores['salesvsbudget'] < 0 ? 'display: inline; vertical-align: middle; float: right; color: red; line-height: 2.5rem;' : 'display: inline; float: right; color: green; line-height: 2.5rem'">{{$store.state.budget.budgetGraphScores['salesvsbudget']}}%</p>
                            <p v-if="$store.state.budget.budgetGraphScores['salesvsbudget'] > 0" :style="$store.state.budget.budgetGraphScores['salesvsbudget'] < 0 ? 'display: inline; vertical-align: middle; float: right; color: red; line-height: 2.5rem;' : 'display: inline; float: right; color: green; line-height: 2.5rem'">+</p>
                        </div>
                        <app-chart-component ref="chart1" title="salesvsbudget" storeModule='budget' endpoint="/budget/graph/rev_vs_budget"></app-chart-component>
                    </el-card>
                </div>

                <div class="spacer col-12 d-lg-none"></div>

                <div class="col-lg-6 col-md-12">
                    <el-card class="box-card" v-if="loadChart">
                        <div slot="header">
                            <h3 class="text-left">Hour costs</h3>
                        </div>
                        <app-chart-component ref="chart2" title="kpuctr" storeModule='budget' endpoint="/budget/graph/kpu_ctr"></app-chart-component>
                    </el-card>
                </div>
            </div>
            <div class="spacer col-12"></div>
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <el-card class="box-card" v-if="loadChart">
                        <div slot="header" class="text-left">
                            <h3 class="inline">Hours vs budget hours</h3>
                            <p :style="$store.state.budget.budgetGraphScores['hoursvsbudget'] > 0 ? 'display: inline; vertical-align: middle; float: right; color: red; line-height: 2.5rem;' : 'display: inline; float: right; color: green; line-height: 2.5rem'">{{$store.state.budget.budgetGraphScores['hoursvsbudget']}}%</p>
                            <p v-if="$store.state.budget.budgetGraphScores['hoursvsbudget'] > 0 " :style="$store.state.budget.budgetGraphScores['hoursvsbudget'] > 0 ? 'display: inline; vertical-align: middle; float: right; color: red; line-height: 2.5rem;' : 'display: inline; float: right; color: green; line-height: 2.5rem'">+</p>
                        </div>
                        <app-chart-component ref="chart3" title="hoursvsbudget" storeModule='budget' endpoint="/budget/graph/hours_vs_budget"></app-chart-component>
                    </el-card>
                </div>

                <div class="spacer col-12 d-lg-none"></div>

                <div class="col-lg-6 col-md-12">
                    <el-card class="box-card" style="height: 100%" v-if="loadChart">
                        <div slot="header">
                            <h3 class="text-left">Employee table</h3>
                        </div>
                        <app-table-component ref="table" title="employeetable" endpoint="/budget/graph/employee_table"></app-table-component>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubNavbar from '../../components/SubNavbar'
import ChartComponent from '../../chart/ChartComponent'
import GraphFilter from '../../components/GraphFilter'
import TableComponent from '../../table/TableComponent'

export default {
    data () {
        return {
            loaded: false,
            loadChart: false
        }
    },
    components: {
        appSubNavbar: SubNavbar,
        appChartComponent: ChartComponent,
        appGraphFilter: GraphFilter,
        appTableComponent: TableComponent
    },
    methods: {
        redrawComponents () {
            for (let i in this.$refs) {
                this.$refs[i].draw()
            }
        }
    },
    created () {
        if (this.$store.getters['budget/storesLoaded'] === false && this.$store.getters['general/storesLoaded'] === true) {
            this.$store.commit('budget/SET_STORES', this.$store.getters['general/getStores'])
            this.loaded = true
        } else if (this.$store.getters['budget/storesLoaded'] === false && this.$store.getters['general/storesLoaded'] === false) {
            this.$store.dispatch('general/getStores').then(response => {
                this.$store.commit('budget/SET_STORES', this.$store.getters['general/getStores'])
                this.loaded = true
            })
        } else {
            this.loaded = true
        }
    }
}
</script>
<style>
.padding-20 {
    padding-left: 20px;
    padding-right: 20px;
}
</style>
